﻿import type { IWishlistService } from '../services/wishlistService';
import type { IParseService } from 'angular';

angular.module('wishlist').directive('wishlistControl', [
    'wishlistService',
    '$parse',
    function (wishlistService: IWishlistService, $parse: IParseService) {
        return {
            restrict: 'A',
            scope: true,
            controller: 'WishlistControlCtrl',
            controllerAs: 'wishlistControl',
            bindToController: true,
            link: function (scope, element, attrs, ctrl) {
                if (attrs.wishlistControl != null && ctrl) {
                    const offerId: number = $parse(attrs.wishlistControl)(scope);
                    ctrl.offerId = offerId;
                    scope.$on('$destroy', function () {
                        wishlistService.removeWishlistScope(offerId, ctrl);
                    });
                    if (ctrl.offerId != null) {
                        wishlistService.addWishlistScope(offerId, ctrl);
                    }
                }
            },
        };
    },
]);

angular.module('wishlist').directive('wishlistCount', function () {
    return {
        restrict: 'A',
        scope: true,
        controller: 'WishlistCountCtrl',
        controllerAs: 'wishlistCount',
        bindToController: true,
        link: function (scope, element, attrs, ctrl) {
            if (ctrl) {
                ctrl.countObj.count = parseInt(attrs.startCount, 10);
            }
        },
    };
});

angular.module('wishlist').directive('wishlistWrapper', [
    'wishlistService',
    'domService',
    function (wishlistService: IWishlistService, domService: any) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs, ctrl) {
                const items = element[0].querySelectorAll<HTMLElement>(attrs.wishlistWrapper);

                if (items != null && items.length > 0) {
                    let dirRemove = document.createElement('a');
                    dirRemove.href = 'javascript:void(0);';
                    dirRemove.setAttribute('role', 'link');
                    dirRemove.className = 'js-wishlist-remove wishlist-remove icon-cancel-circled-before link-text-decoration-none cs-l-5';

                    for (let i = items.length - 1; i >= 0; i--) {
                        items[i].appendChild(dirRemove.cloneNode());

                        items[i].addEventListener('click', function (event: Event) {
                            const item = this;
                            const target = event.target as Element;
                            if (target?.classList.contains('js-wishlist-remove')) {
                                const offerId = Number(item.getAttribute('data-offer-id'));
                                if (!Number.isNaN(offerId)) {
                                    wishlistService.remove(Number(offerId)).then(function () {
                                        const blockForDelete = domService.closest(item, '.js-products-view-block');
                                        blockForDelete.parentNode.removeChild(blockForDelete);
                                    });
                                }
                            }
                        });
                    }
                }
            },
        };
    },
]);
